import React from "react";
import { LogIn, ShieldCheck } from "lucide-react";
import SeoHead from "@/components/SeoHead";

const REDIRECT_URL = (typeof window !== "undefined" ? window.location.origin : "") + "/admin/auth-callback";
const AUTH_URL = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(REDIRECT_URL)}`;

export const AdminLogin = () => {
  return (
    <div className="min-h-screen flex items-center justify-center px-5" style={{ background: "#0A0A0A", color: "#FDFBF7" }} data-testid="admin-login-page">
      <SeoHead title="Kerala Speaks Admin — Sign in" description="Admin sign-in" noindex />
      <div className="brutal-card p-7 md:p-10 max-w-md w-full" style={{ background: "#141414", borderColor: "#FF9933", color: "#FDFBF7" }}>
        <p className="text-xs uppercase font-bold tracking-[0.4em]" style={{ color: "#FF9933" }}>
          ★ KERALA SPEAKS · ADMIN ★
        </p>
        <h1 className="font-display uppercase leading-[0.9] tracking-tight mt-3 mb-4" style={{ fontSize: "clamp(2rem, 5vw, 3rem)", color: "#FDFBF7" }} data-testid="admin-login-title">
          Sign in to continue.
        </h1>

        <a
          href={AUTH_URL}
          className="brutal-btn w-full justify-center"
          style={{ background: "#FF9933", color: "#0A0A0A", borderColor: "#FF9933" }}
          data-testid="admin-google-signin"
        >
          <LogIn size={18} strokeWidth={3} className="mr-2" />
          Continue with Google
        </a>

        <div className="flex items-start gap-2 mt-5 text-xs text-neutral-400 font-bold tracking-wide">
          <ShieldCheck size={14} strokeWidth={3} className="shrink-0 mt-0.5" style={{ color: "#138808" }} />
          <p data-testid="admin-login-secure-line">Secure Session</p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
